module.exports = __webpack_public_path__ + "img/web-agency.dc53d05e.png";